// extracted by mini-css-extract-plugin
export var messageSideLeft = "_m8-1";
export var messageSideRight = "_m8-2";
export var subscribeToBackInStockBubbleContainer = "_m8-0";